import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminAiRoutingModule } from './admin-ai-routing.module';
import { AdminAiComponent } from './admin-ai.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, SharedPipesModule, AdminAiRoutingModule, NgxTippyModule],
  declarations: [AdminAiComponent],
})
export class AdminAiModule {}
